import axios from "@/plugins/axios";
// import * as example from "./example";

let url = "/api/v1/me/gifts";

export const gifts = {
    // ...example,
    gets(data){
        return axios.get(url, data).then(result => result.data);
    },
    get(data){
        return axios.get(`${url}/${data._id}`).then(result => result.data);
    },

    post(data){
        return axios.post(`${url}`, data).then(result => result.data);
    },

    take(data){
        return axios.put(`${url}/${data._id}/take`).then(result => result.data);
    },

    allTake(data){
        return axios.put(`${url}/take`).then(result => result.data);
    },

    resend(data){
        return axios.post(`${url}/${data._id}/resend`).then(result => result.data);
    },

    cancel(data){
        return axios.put(`${url}/${data._id}/cancel`).then(result => result.data);
    },

    reject(data){
        return axios.put(`${url}/${data._id}/reject`).then(result => result.data);
    },
    
    remove(data){
        return axios.put(`${url}/remove`, data).then(result => result.data)
    }
}
